import React from "react";
import { useCurrentOrg } from "../../../user/hooks/userHooks";
import { Navigate } from "react-router-dom";

interface CanViewChallengeSetPerformanceNavItemGuardProps {
  children: JSX.Element;
}

function CanViewChallengeSetPerformanceNavItemGuard({
  children,
}: CanViewChallengeSetPerformanceNavItemGuardProps) {
  const currentOrg = useCurrentOrg();

  if (!currentOrg?.featureFlags?.canViewChallengeSetPerformance) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
}

export default CanViewChallengeSetPerformanceNavItemGuard;
